export function getPlausibleScript(): HTMLScriptElement {
  const script = document.createElement('script');

  script.defer = true;
  script.setAttribute('data-domain', location.hostname);
  script.src = 'https://webax.svc.sys.decafhub.com/js/plausible.js';

  return script;
}
